import React, { useEffect, useState } from "react";

const PAIRS = [
  { s: "EUR/USD", base: "EUR" },
  { s: "GBP/USD", base: "GBP" },
  { s: "USD/JPY", base: "JPY", inverse: true },
  { s: "AUD/USD", base: "AUD" },
  { s: "USD/CAD", base: "CAD", inverse: true },
  { s: "USD/CHF", base: "CHF", inverse: true },
  { s: "NZD/USD", base: "NZD" },
  { s: "EUR/GBP", base: "EUR", quote: "GBP" },
];

export const TickerRibbon = ({ rates }) => {
  const [seed] = useState(() => Math.random());

  const items = PAIRS.map((p, i) => {
    let price = 1;
    if (rates && Object.keys(rates).length) {
      if (p.quote) price = (rates[p.quote] || 1) / (rates[p.base] || 1);
      else if (p.inverse) price = rates[p.base] || 1;
      else price = 1 / (rates[p.base] || 1);
    }
    const change = (Math.sin(seed * (i + 1) * 9.13) * 0.55).toFixed(2);
    const up = parseFloat(change) >= 0;
    const decimals = p.s.includes("JPY") ? 3 : 5;
    return { symbol: p.s, price: price.toFixed(decimals), change, up };
  });

  const row = [...items, ...items];

  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-[#0C1017] py-2.5" data-testid="market-ticker-ribbon">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((it, i) => (
          <div key={i} className="flex items-center gap-2 px-6 border-r border-white/5">
            <span className="font-data text-xs text-slate-400">{it.symbol}</span>
            <span className="font-data text-xs text-white font-medium">{it.price}</span>
            <span className={`font-data text-[11px] ${it.up ? "text-gain" : "text-loss"}`}>
              {it.up ? "▲" : "▼"} {Math.abs(it.change)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
